import React, { useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";
import { motion, useSpring } from "framer-motion";

export const ReadingProgressBar: React.FC = () => {
    const [progress, setProgress] = useState(0);
    const smoothProgress = useSpring(progress, {
        stiffness: 80,
        damping: 20,
        mass: 0.4,
    });

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
            setProgress(pct);
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <Box
            position="fixed"
            top={0}
            left={0}
            right={0}
            h="2px"
            zIndex={9999}
            bg="transparent"
        >
            <motion.div
                style={{
                    height: "2px",
                    background: "linear-gradient(90deg, #C9A84C, #8B9E6E)",
                    boxShadow: "0 0 8px rgba(201,168,76,0.5)",
                    width: smoothProgress,
                }}
            />
        </Box>
    );
};